import { render, staticRenderFns } from "./TS12.vue?vue&type=template&id=4cb1a664&scoped=true&"
import script from "./TS12.vue?vue&type=script&lang=js&"
export * from "./TS12.vue?vue&type=script&lang=js&"
import style0 from "./TS12.vue?vue&type=style&index=0&id=4cb1a664&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb1a664",
  null
  
)

export default component.exports